// API functions for ownership roles.

import type { ApiClient } from './client'

export interface OwnershipRole {
  id: string
  label: string
  current_owner_id: string
  owner_display_name: string
  created_at: string
}

export interface CreateOwnershipRoleRequest {
  label: string
}

export function ownershipRolesApi(api: ApiClient) {
  return {
    list: () => api.get<OwnershipRole[]>('/ownership-roles'),
    create: (data: CreateOwnershipRoleRequest) => api.post<OwnershipRole>('/ownership-roles', data),
  }
}
